import _CardContent from "@mui/material/CardContent";
import _Card from "@mui/material/Card";
import _Box from "@mui/material/Box";
import _Grid from "@mui/material/Grid";
import _Typography from "@mui/material/Typography";
import _Skeleton from "@mui/material/Skeleton";
import React from 'react';
import { Trans } from 'react-i18next';
import { styled } from 'styled-components';
import { defaultEnvironment } from '../environment';
import { useUnits } from '../hooks';
import { CaloriesIcon, DistanceIcon, DurationIcon, FlagIcon, SavedCO2Icon, VerticalGainIcon } from './icons';
export function StatsCard({
  showDistance,
  showElevationGain,
  showSteps,
  hideCalories,
  hideCO2Saved,
  hideDuration,
  enableDays,
  data
}) {
  const {
    toDistance,
    toTime
  } = useUnits();
  return /*#__PURE__*/React.createElement(_Card, {
    sx: {
      borderRadius: 2
    },
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(StyledCardContent, null, /*#__PURE__*/React.createElement(_Grid, {
    container: true,
    spacing: 4,
    sx: {
      width: '100%'
    }
  }, showDistance && /*#__PURE__*/React.createElement(_Grid, {
    size: 6
  }, /*#__PURE__*/React.createElement(StyledGridContent, null, /*#__PURE__*/React.createElement(DistanceIcon, {
    color: data ? 'primary' : 'action'
  }), /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    component: "div",
    variant: "subtitle1"
  }, data ? toDistance(data.distance) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  })))), showElevationGain && (!data || data.verticalGain !== undefined) && /*#__PURE__*/React.createElement(_Grid, {
    size: 6
  }, /*#__PURE__*/React.createElement(StyledGridContent, null, /*#__PURE__*/React.createElement(VerticalGainIcon, {
    color: data ? 'primary' : 'action'
  }), /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    component: "div",
    variant: "subtitle1"
  }, data ? toDistance(data.verticalGain || 0) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  })))), showSteps && /*#__PURE__*/React.createElement(_Grid, {
    size: 6
  }, /*#__PURE__*/React.createElement(StyledGridContent, null, /*#__PURE__*/React.createElement(FlagIcon, {
    color: data ? 'primary' : 'action'
  }), /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    component: "div",
    variant: "subtitle1"
  }, data ? /*#__PURE__*/React.createElement(Trans, {
    count: data.nbSteps || 0,
    i18nKey: "geovelo.trip.steps",
    values: {
      count: data.nbSteps || 0
    }
  }) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  })))), !hideDuration && /*#__PURE__*/React.createElement(_Grid, {
    size: 6
  }, /*#__PURE__*/React.createElement(StyledGridContent, null, /*#__PURE__*/React.createElement(DurationIcon, {
    color: data ? 'primary' : 'action'
  }), /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    component: "div",
    variant: "subtitle1"
  }, data ? enableDays ? /*#__PURE__*/React.createElement(Trans, {
    count: data.duration,
    i18nKey: "commons.day",
    values: {
      count: data.duration
    }
  }) : toTime(data.duration) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  })))), !hideCalories && /*#__PURE__*/React.createElement(_Grid, {
    size: 6
  }, /*#__PURE__*/React.createElement(StyledGridContent, null, /*#__PURE__*/React.createElement(CaloriesIcon, {
    color: data ? 'primary' : 'action'
  }), /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    component: "div",
    variant: "subtitle1"
  }, data ? /*#__PURE__*/React.createElement(React.Fragment, null, Math.round((data.calories || 0) / 1000), " kcal") : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  })))), !hideCO2Saved && /*#__PURE__*/React.createElement(_Grid, {
    size: 6
  }, /*#__PURE__*/React.createElement(StyledGridContent, null, /*#__PURE__*/React.createElement(SavedCO2Icon, {
    color: data ? 'primary' : 'action'
  }), /*#__PURE__*/React.createElement(_Box, null, /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    component: "div",
    variant: "subtitle1"
  }, data ? /*#__PURE__*/React.createElement(React.Fragment, null, (data.distance / 1000 * defaultEnvironment.savedKgOfCO2PerKilometer).toFixed(1), ' ', "kg") : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  })), /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    color: "textSecondary",
    variant: "body2"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.routing.detail.co2_saved"
  }))))))));
}
const StyledCardContent = styled(_CardContent)`
  && {
    padding: 24px;
  }
`;
const StyledGridContent = styled.div`
  align-items: center;
  display: flex;

  svg {
    flex-shrink: 0;
    margin-right: 16px;
  }
`;